/**
 * gearRentalIconSingleton.js
 * Created by Destin Frasier on 12/19/19.
 */

import { IconSingleton } from '../iconSingleton';

class GearRentalIconsSingleton extends IconSingleton {
    constructor() {
        super();

        this.notificationName = 'icons-gearRental.loaded';
        this.svgPath = `${process.env.CDN}/graphics/gearRentalIcons.svg`;
    }
}

const instance = new GearRentalIconsSingleton();
export default instance;
